import { stateAbbreviationResolver } from "../../../../../data/utils/stateUtil";

export const convertMappedValue = (value, type) => {
  switch (type) {
    case "state":
      return stateAbbreviationResolver(value);
    default:
      return value;
  }
};
